// import React from "react";
export const SelectedTextStyle = {
    color: "rgba(140,140,140,1)",
     marginLeft: 10,
     cursor:'pointer', 
  } as React.CSSProperties;

  export const appSharedColors ={
    primaryColor:'#ffa600'
  }